import React from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import MeterToggleSwitch from "./meterToggleSwitch";

const meterHeadLineState = createSelector(
  (common: IApplicationState) => common.common,
  (meter: IApplicationState) => meter.meters,
  (common, meter) => ({
    phoneNumbers: common.currentUserInfo.PhoneNumbers,
    domainCode: common.selectedDomain?.Code ?? "",
    meters: meter.meters,
    monitoringOn: meter.monitoringOn,
  })
);

export const MeterHeadline = () => {
  const { phoneNumbers, domainCode, meters, monitoringOn } =
    useSelector(meterHeadLineState);
  return (
    <>
      <MeterToggleSwitch
        domainCode={domainCode}
        meters={meters}
        monitoringOn={monitoringOn}
        phoneNumbers={phoneNumbers || []}
      />
    </>
  );
};
